<script setup lang="ts">
import type { DefaultLayoutProperties } from '@optionway/models';

const { $appConfig } = useNuxtApp();
// Every link stays optional: when the partner configuration is unavailable, the app must keep
// serving with the environment config alone (app = { env } — no layouts block) instead of a 500.
const config = $appConfig.app?.layouts?.default;

const layoutConfig = computed<DefaultLayoutProperties>(() => {
  return {
    disableCookieBot: config?.disableCookieBot,
    components: config?.components,
    hideComponents: config?.hideComponents,
  };
});
</script>

<template>
  <UiTooltipProvider :delay-duration="200">
    <div class="flex min-h-screen flex-col font-primary font-semibold">
      <nav
        :aria-label="$t('app.skipLinks.ariaLabel')"
        class="sr-only bg-secondary text-secondary-foreground shadow focus-within:not-sr-only"
      >
        <ul class="flex justify-center gap-6 py-3">
          <li>
            <NuxtLink
              class="bg-0 rounded-md p-2 text-brand-primary-700 shadow-none outline-none focus-visible:border-2 focus-visible:border-brand-primary-700 focus-visible:ring-0"
              to="#main"
            >
              {{ $t('app.skipLinks.toMainContent') }}
            </NuxtLink>
          </li>
          <li>
            <NuxtLink
              class="bg-0 rounded-md p-2 text-brand-primary-700 shadow-none outline-none focus-visible:border-2 focus-visible:border-brand-primary-700 focus-visible:ring-0"
              to="#footer"
            >
              {{ $t('app.skipLinks.toFooter') }}
            </NuxtLink>
          </li>
        </ul>
      </nav>

      <CommonHeader
        v-if="!layoutConfig.hideComponents?.commonHeader"
        :logo-alt="layoutConfig.components?.commonHeader?.logoAlt"
        :logo-name="layoutConfig.components?.commonHeader?.logoName"
      />
      <main
        id="main"
        class="flex flex-1 flex-col outline-none"
      >
        <slot />
      </main>
      <CommonFooter v-if="!layoutConfig.hideComponents?.commonFooter" />
      <CommonOfferExpiration />
    </div>
  </UiTooltipProvider>
</template>
